module.exports = "https://static.wanderu.com/ui-react/_next/static/media/train-grey.165fd6ed.svg";